import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Environment from '../views/Environment.vue'
import Teachers from '../views/Teachers.vue'
import History from '../views/History.vue'
import Facilities from '../views/Facilities.vue'
import Honors from '../views/Honors.vue'
import Works from '../views/Works.vue'
import Admissions from '../views/Admissions.vue'
import NewsDetail from '../views/NewsDetail.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                depth: 0,
                title: '首页'
            }
        },
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: {
                depth: 1,
                title: '学校介绍'
            }
        },
        {
            path: '/environment',
            name: 'environment',
            component: Environment,
            meta: {
                depth: 1,
                title: '学校环境'
            }
        },
        {
            path: '/teachers',
            name: 'teachers',
            component: Teachers,
            meta: {
                depth: 1,
                title: '师资介绍'
            }
        },
        {
            path: '/history',
            name: 'history',
            component: History,
            meta: {
                depth: 1,
                title: '历史成绩'
            }
        },
        {
            path: '/facilities',
            name: 'facilities',
            component: Facilities,
            meta: {
                depth: 1,
                title: '校园设施'
            }
        },
        {
            path: '/honors',
            name: 'honors',
            component: Honors,
            meta: {
                depth: 1,
                title: '荣誉记录'
            }
        },
        {
            path: '/works',
            name: 'works',
            component: Works,
            meta: {
                depth: 1,
                title: '优秀作业'
            }
        },
        {
            path: '/admissions',
            name: 'admissions',
            component: Admissions,
            meta: {
                depth: 1,
                title: '升学数据'
            }
        },
        {
            path: '/news/:id',
            name: 'NewsDetail',
            component: NewsDetail,
            props: true
        }
    ]
})
